/* eslint-disable no-unused-vars */
/* global G */
import { curry, getKey } from 'lib/util'

/**
 * Generates a URL from the given `action`, `module` and `context`.
 *
 * @param {string|null} [route=null]      optional route to read from the configuration if
 *                                        there are more than one defined
 * @param {Gaia.AppModule.Spec} module    app module
 * @param {Gaia.Component.Spec} component action component
 * @param {Gaia.PlatformEvent} event      event
 * @returns {`#/${*}/${*}/${*}`}
 */
export const _url = (route, module, component, event) => {
  const model = module[G.MODEL]
  const context = getKey(G.CONTEXT, module[G.ADAPTER][G.SESSION][G.STATE])
  const { ref = null } = event?.detail || event || {}

  const routeSource = route
    ? component[G.CONFIGURATION].route[route]
    : component[G.CONFIGURATION].route

  const {
    module: targetModule = model[G.CONFIGURATION].module,
    action,
  } = routeSource

  return `#/${context}/${targetModule}/${action}${ref ? `/${ref}` : ''}`
}

/**
 * creates href link from given component
 *
 * @example
 * {
 *  module: 'Card/Form',
 *  view: 'Element/Section/AsLink',
 *  options: {
 *    md: 12,
 *    xl: 12,
 *    events: {
 *      onOpen: 'linkTo',
 *    },
 *    target: '_blank',
 *  },
 *  route: {
 *    action: 'detail',
 *  },
 *  ...
 *  }
 *
 * @type {Gaia.AppModule.EventHandler}
 * @returns {string}
 */
const link = (module, component, event) => {
  const state = component[G.STATE]

  const url = _url(null, module, component, event)

  const key = state.key
      || event?.key
      || state.value?.[0]?.key
      || state.value?.key

  return key
    ? `${url}/${key}`
    : null
}

export default curry(link)
